import React, { useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { withViewport } from '../../../util/uiHelpers';
import { injectIntl } from '../../../util/reactIntl';
import { isScrollingDisabled } from '../../../ducks/ui.duck';

import { LayoutSingleColumn, Page } from '../../../components';

import TopbarContainer from '../../TopbarContainer/TopbarContainer';
import FooterContainer from '../../FooterContainer/FooterContainer';
import MainSearchContent from './MainSearchContent/MainSearchContent';

import css from './AlgoliaSearchPage.module.css';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { useConfiguration } from '../../../context/configurationContext';
import { setActiveListing } from './AlgoliaSearchPage.duck';
import MobileBottomNavbar from '../../../components/MobileBottomNavbar/MobileBottomNavbar';

function AlgoliaSearchPageComponent(props) {
  const { scrollingDisabled } = props;
  const [scrolling, setScrolling] = useState(false);

  return (
    <Page title={'Search Page'} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        className={css.pageRoot}
        topbar={<TopbarContainer notShowDesktopSearchBar={true} />}
        footer={<FooterContainer />}
        mobileBottomNavbar={<MobileBottomNavbar setScrolling={setScrolling} />}
      >
        <MainSearchContent {...props} scrolling={scrolling} />
      </LayoutSingleColumn>
    </Page>
  );
}

const mapStateToProps = state => {
  const {
    activeListingId,
    facets,
    facetsInProgress,
    facetsError,
    algoliaQueryInProgress,
    algoliaQueryError,
    algoliaListings,
    algoliaStores,
    nbHitsInsideBounds
  } = state.AlgoliaSearchPage;
  const {
    currentUserLocationInfo,
    currentUserCurrency,
    currentUser,
  } = state.user;
  const { exchangeRates } = state.exchangeRate;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUserLocationInfo,
    currentUserCurrency,
    exchangeRates,
    currentUser,
    activeListingId,
    facets,
    facetsInProgress,
    facetsError,
    algoliaQueryInProgress,
    algoliaQueryError,
    algoliaListings,
    algoliaStores,
    nbHitsInsideBounds
  };
};

const mapDispatchToProps = dispatch => ({
  onActivateListing: listingId => dispatch(setActiveListing(listingId)),
});

const EnhansedSearchPage = props => {
  const routesConfiguration = useRouteConfiguration();
  const config = useConfiguration();
  return (
    <AlgoliaSearchPageComponent
      routesConfiguration={routesConfiguration}
      config={config}
      {...props}
    />
  );
};

const AlgoliaSearchPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withViewport,
  injectIntl,
  withRouter
)(EnhansedSearchPage);

export default AlgoliaSearchPage;
